export type NotificationChannel = "SMS" | "EMAIL" | "PUSH";
export type NotificationEvent = "ORDER_DESIGN_OPENED";

export type NotificationSubscription = {
  [key in NotificationChannel]?: boolean;
};

export type NotificationSubscriptions = {
  [key in NotificationEvent]?: NotificationSubscription;
};

export const NotificationChannelEnum: { [key in NotificationChannel]: key } = {
  SMS: "SMS",
  EMAIL: "EMAIL",
  PUSH: "PUSH",
};

export const NotificationEventEnum: { [key in NotificationEvent]: key } = {
  ORDER_DESIGN_OPENED: "ORDER_DESIGN_OPENED",
};
